/*
 * Title: GentleApi Obejct
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
  type: {
    Bot: "Bot",
    BotNon: "BotNon",
    // BotEdit: "BotEdit",
    // BotEditNon: "BotEditNon",
    Title: "Title",
    Done: "Done",
    Edit: "Edit",
    DoneBot: "DoneBot",
    ImageSelected: "ImageSelected",
    Complete: "Complete",
    Home: "Home",
    InComplete: "InComplete",
  },
  tomy: {
    kr: {
      InComplete: "프로필 등록에 실패했습니다.",
      Bot: "{name}님, 반갑습니다! 아래 [프로필 이미지 등록하기]를 누르면 프로필에 들어갈 이미지를 선택하실 수 있어요.",
      BotNon: "나만의 프로필을 완성해보세요.",
      // BotEdit:
      //   "아래 [프로필 이미지 변경하기] 버튼을 누르면 프로필 이미지를 변경하실 수 있습니다.",
      // BotEditNon:
      //   "아래 [프로필 이미지 변경하기] 버튼을 누르면 프로필 이미지를 변경하실 수 있습니다.",
      Title: "나만의 프로필을 확인해보세요!",
      Done: "프로필 이미지 등록하기",
      Edit: "프로필 이미지 변경하기",
      DoneBot: "프로필 이미지 변경이 완료되었습니다.",
      ImageSelected: "프로필 이미지 선택 완료",
      Complete: "프로필 카드가 완성되었습니다!",
      Home: '업무를 시작하시려면 왼쪽 아래 <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon">버튼을 누른 후 [처음으로]를 선택해주세요.',
    },
    eng: {
      InComplete: "Profile registration failed.",
      Bot: "Nice to meet you, {name}! If you click [Register profile picture] below, you can select a picture for your profile.",
      BotNon: "Complete your own profile.",
      // BotEdit:
      //   "You can change your profile image by clicking the [Change Profile Image] button below.",
      // BotEditNon:
      //   "You can change your profile image by clicking the [Change Profile Image] button below.",
      Title: "Check out your own profile!",
      Done: "Register profile picture",
      Edit: "Change Profile Image",
      DoneBot: "Profile image change is complete.",
      ImageSelected: "Profile image selection complete",
      Complete: "Your profile card is complete!",
      Home: 'To start working, click the <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> button in the lower left and select [First].',
    },
  },
  papa: {
    kr: {
      InComplete: "프로필 등록에 실패했어요. 다시 한번 시도해보시겠어요? ",
      Bot: "이렇게 만나서 정말 반가워요^^ 내가 {name}님을 잘 기억할 수 있게 프로필 이미지를 등록해주겠어요?",
      BotNon: "나만의 프로필을 완성해보세요.",
      // BotEdit:
      //   "오, 새로운 사진인가요? 아래 버튼을 누르면 이미지를 변경할 수 있어요.",
      // BotEditNon:
      //   "오, 새로운 사진인가요? 아래 버튼을 누르면 이미지를 변경할 수 있어요.",
      Title: "나만의 프로필을 확인해보세요!",
      Done: "프로필 이미지 등록하기",
      Edit: "프로필 이미지 변경하기",
      DoneBot: "프로필 이미지가 원하는 대로 잘 바뀌었는지 확인해보면 좋겠군요!",
      ImageSelected: "프로필 이미지 선택 완료",
      Complete: "프로필 카드가 완성되었습니다!",
      Home: '이제 본격적으로 애터미를 둘러볼까요? 왼쪽 아래 <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon">버튼을 누른 다음 [처음으로]를 선택해보세요.',
    },
    eng: {
      InComplete: "Profile registration Would you like to try again?",
      Bot: "Nice to meet you like this Could you add a profile image to help me remember {name}?",
      BotNon: "Complete your own profile.",
      // BotEdit:
      //   "Oh, is this a new picture? You can change the image by clicking the button below.",
      // BotEditNon:
      //   "Oh, is this a new picture? You can change the image by clicking the button below.",
      Title: "Check out your own profile!",
      Done: "Register profile picture",
      Edit: "Change Profile Image",
      DoneBot:
        "It would be nice to see if the profile image has been changed as desired!",
      ImageSelected: "Profile image selection complete",
      Complete: "Your profile card is complete!",
      Home: 'Now, shall we take a look around Atomy in earnest? Click the <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> button in the lower left and then select [First].',
    },
  },
};
